import { useMediaQuery } from "react-responsive";
import { followUserService } from "../../../infrastructure/services/UserInfoService";
import { Button } from "antd";
import { USER_CONNECTIONS_CHANGED_EVENT } from "../../../infrastructure/hooks/useGetFollowers";


export const FollowUser = ({
  userData,
  userToFollow,
  texts,
  disable,
  setSendReq,
  back,
  onSuccess,
  label,
}) => {
  const isMobile = useMediaQuery({maxWidth: 1024})
 
  const onClickFollow = async () => {
    try {
      const req = {
        idUsuario: userData?.idUsuario,
        idAmigo: userToFollow?.idUsuario,
      };
      await followUserService(req);
      window.dispatchEvent(
        new CustomEvent(USER_CONNECTIONS_CHANGED_EVENT, { detail: req }),
      );
      setSendReq(true);
      onSuccess?.();
    } catch (error) {
      console.error("Failed follow user ", error);
    }
  };

  return (
    <>
      <div>
        <Button
          onClick={onClickFollow}
          disabled={disable}
         style={{
              background: "#f18b6f",
              borderColor: "#f18b6f",
              color: "white",
              padding: "12px 10px",
              fontSize: isMobile ? "12px": "16px",
              fontWeight: "bold",
              borderRadius: "999px",
              minWidth: "10px",
            }}
        >
          {label || (!back ? texts?.LB0130 : texts?.LB0150)}
        </Button>
      </div>
    </>
  );
};
